import React from 'react';
import PrimaryButton from './PrimaryButton';
import './ErrorPage.css';

const ErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-content">
        <h1>Oeps! Er is iets misgegaan</h1>
        <p>We hebben een foutje gemaakt. Probeer de pagina te verversen.</p>
        <PrimaryButton onClick={handleRefresh}>
          Ververs de pagina
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ErrorPage; 